export default "__VITE_ASSET__Dai5OF$5__"